module.exports = __webpack_public_path__ + "images/site-plan-example-d024b505c4c8a08740e275c58d2a1da0.png";